<template>
  <div id="app">
    <router-view />
    <!--  -->
     <div ref="iframe2" class="iframe" id="iframe2">
      <iframe
        ref="iframe"
        src="./mms3D/index.html"
        frameborder="0"
        style="width: 100%; height: 100%"
        id="iframe"
      ></iframe>
    </div>
  </div>
</template>


<script>
  export default {
  components: {
    
  },
  data() {
    return {
    }
  },
  methods: {
    gosplit(){
      this.$router.push('/split')
    }
  },
  mounted() {
    // document.getElementById('myVideo').play();
    window.gosplit = this.gosplit
  },
};
</script>

<style lang="less">

/* 把我们所有标签的内外边距清零 */
* {
  margin: 0;
  padding: 0;
}

.iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  border: medium none;
}

@font-face {
  font-family: "pmzd";   //给引入的字体起个名字
  src: url("./assets/pmzd.TTF");  //引入字体文件
}

/* em 和 i 斜体的文字都不倾斜 */
em,
i {
  font-style: normal;
}

/* 去掉每个li前面的小圆点 */
li {
  list-style: none;
  
}

img {
  border: 0; /* 为了照顾低版本浏览器,如果 图片的外面包含了链接 会出现边框的问题 */
  vertical-align: middle; /* 解决图片底侧出现空白缝隙的问题 */
}

button {
  cursor: pointer; /* 当我们鼠标经过button按钮时,鼠标变成小手的样子 */
}

a {
  color: #666;
  text-decoration: none;
}

a:hover {
  color: #c81623;
}

button,
input {
  font-family: Microsoft YaHei, Heiti SC, tahoma, arial, Hiragino Sans GB,
    "\5B8B\4F53", sans-serif;
}

body {
  /* 抗锯齿性,避免文字被放大后会产生锯齿 */
  -webkit-font-smoothing: antialiased;
  background-color: #fff;
  /* 12px/1.5 表示所有字体的大小为12px,1.5倍的行高 */
  /* "\5B8B\4F53" 代表的是宋体，用这种方式，浏览器的兼容性会比较好。 把中文字体的名称用相应的Unicode编码来代替，这样就可以有效地避免浏览器解释CSS代码时出现乱码的情况*/
  font: 12px/1.5 Microsoft YaHei, Heiti SC, tahoma, arial, Hiragino Sans GB,
    "\5B8B\4F53", sans-serif;
  color: #666;
}

.hide,
.none {
  display: none;
}

/* 清除浮动 */
.clearfix:after {
  visibility: hidden;
  clear: both;
  display: block;
  content: ".";
  height: 0;
}

.clearfix {
  *zoom: 1;
}
</style>
